<template>
  <div class="page">
    <!-- 头部 -->
    <AboutHeader></AboutHeader>
    <!-- 内容 -->
    <div class="content">
      <img src="../../assets/images/map.png" alt="">

      <div class="company">
        <span>博雅数字（辽宁）经济发展有限公司</span>
        <p>地址：沈阳市浑南区全运五路 35 号（自贸区）沈阳国际设计谷 2 号楼 3 楼</p>
        <p>电话：024-2296-5511 </p>
        <p>邮编：110179</p>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import AboutHeader from "@/components/page/AboutHeader.vue";
export default {
  components: {
    Footer,
    AboutHeader
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped>
.page .content {
  width: 100%;
  margin-top: 150px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 100px;
}
.page .content img {
  display: block;
  width: 100%;
  height: 100%;
}
.page .content .company {
  margin-top: 60px;
  font-size: 24px;
  line-height: 40px;
}
.page .content .company span {
  color: #222222;
}


</style>